import { APP_NAME } from "@calcom/lib/constants";
import classNames from "@calcom/ui/classNames";

export function Logo({
  small,
  icon,
  inline = true,
  className,
  src = "/api/logo",
}: {
  small?: boolean;
  icon?: boolean;
  inline?: boolean;
  className?: string;
  src?: string;
}) {
  return (
    <h3 className={classNames("logo", inline && "inline")}>
      <strong>
        {icon ? (
          <img
            className={classNames("mx-auto w-9 dark:invert", className)}
            alt={APP_NAME}
            title={APP_NAME}
            src={`${src}?type=icon`}
          />
        ) : (
          <img
            className={classNames(small ? "h-4 w-auto" : "h-5 w-auto", "dark:invert", className)}
            alt={APP_NAME}
            title={APP_NAME}
            src={src}
          />
        )}
      </strong>
    </h3>
  );
}
